/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: grxNYctbMek6PL66cujx3u

import * as React from "react";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: grxNYctbMek6PL66cujx3u/projectModule
import { AuthGlobalContext } from "@/common/fragment/authGlobalContext"; // plasmic-import: Zp2TCd6iY4kZ/codeComponent
import { Fragment } from "@/common/fragment/designSystemGlobalContext"; // plasmic-import: vZbgq5bYK1Sy/codeComponent
import { GrowthbookGlobalContext } from "@/common/fragment/growthbookGlobalContext"; // plasmic-import: Lh7MsDRxKvrC/codeComponent
import { Splunk } from "@/common/fragment/splunk"; // plasmic-import: dI_F7URPFmvR/codeComponent
import { PWA } from "@/common/fragment/pwa"; // plasmic-import: 6WQFMgFgcDau/codeComponent
import { EmbedCss } from "@plasmicpkgs/plasmic-embed-css";
import { HamdastAppsSelectorModalProvider } from "@/modules/hamdast/components/apps-selector-modal"; // plasmic-import: 5xb4SWXtsvF4/codeComponent

export interface GlobalContextsProviderProps {
  children?: React.ReactElement;
  authGlobalContextProps?: Partial<
    Omit<React.ComponentProps<typeof AuthGlobalContext>, "children">
  >;

  fragmentProps?: Partial<
    Omit<React.ComponentProps<typeof Fragment>, "children">
  >;

  growthbookGlobalContextProps?: Partial<
    Omit<React.ComponentProps<typeof GrowthbookGlobalContext>, "children">
  >;

  splunkProps?: Partial<Omit<React.ComponentProps<typeof Splunk>, "children">>;
  pwaProps?: Partial<Omit<React.ComponentProps<typeof PWA>, "children">>;
  embedCssProps?: Partial<
    Omit<React.ComponentProps<typeof EmbedCss>, "children">
  >;

  hamdastAppsSelectorModalProviderProps?: Partial<
    Omit<
      React.ComponentProps<typeof HamdastAppsSelectorModalProvider>,
      "children"
    >
  >;
}

export default function GlobalContextsProvider(
  props: GlobalContextsProviderProps
) {
  const {
    children,
    authGlobalContextProps,
    fragmentProps,
    growthbookGlobalContextProps,
    splunkProps,
    pwaProps,
    embedCssProps,
    hamdastAppsSelectorModalProviderProps
  } = props;

  return (
    <AuthGlobalContext
      {...authGlobalContextProps}
      previewToken={
        authGlobalContextProps && "previewToken" in authGlobalContextProps
          ? authGlobalContextProps.previewToken!
          : undefined
      }
    >
      <Fragment
        {...fragmentProps}
        apiConfig={
          fragmentProps && "apiConfig" in fragmentProps
            ? fragmentProps.apiConfig!
            : { withCredentials: true }
        }
        previewApiConfig={
          fragmentProps && "previewApiConfig" in fragmentProps
            ? fragmentProps.previewApiConfig!
            : undefined
        }
      >
        <GrowthbookGlobalContext
          {...growthbookGlobalContextProps}
          apiHost={
            growthbookGlobalContextProps &&
            "apiHost" in growthbookGlobalContextProps
              ? growthbookGlobalContextProps.apiHost!
              : "https://growthbook-api.paziresh24.com"
          }
          clientKey={
            growthbookGlobalContextProps &&
            "clientKey" in growthbookGlobalContextProps
              ? growthbookGlobalContextProps.clientKey!
              : "sdk-St1dBftdp07geqtD"
          }
          previewAttributes={
            growthbookGlobalContextProps &&
            "previewAttributes" in growthbookGlobalContextProps
              ? growthbookGlobalContextProps.previewAttributes!
              : undefined
          }
        >
          <Splunk
            {...splunkProps}
            defaultApiHost={
              splunkProps && "defaultApiHost" in splunkProps
                ? splunkProps.defaultApiHost!
                : "https://hamdast-splunk-hec.paziresh24.com"
            }
            defaultApiKey={
              splunkProps && "defaultApiKey" in splunkProps
                ? splunkProps.defaultApiKey!
                : "c2b3263e-4c92-4cb6-99dc-a5834b7f0773"
            }
          >
            <PWA {...pwaProps}>
              <EmbedCss
                {...embedCssProps}
                css={
                  embedCssProps && "css" in embedCssProps
                    ? embedCssProps.css!
                    : ".pl__z-50{\r\n  z-index: 9999 !important;\r\n}"
                }
              >
                <HamdastAppsSelectorModalProvider
                  {...hamdastAppsSelectorModalProviderProps}
                  onAppSelect={
                    hamdastAppsSelectorModalProviderProps &&
                    "onAppSelect" in hamdastAppsSelectorModalProviderProps
                      ? hamdastAppsSelectorModalProviderProps.onAppSelect!
                      : undefined
                  }
                >
                  {children}
                </HamdastAppsSelectorModalProvider>
              </EmbedCss>
            </PWA>
          </Splunk>
        </GrowthbookGlobalContext>
      </Fragment>
    </AuthGlobalContext>
  );
}
